import { render, staticRenderFns } from "./main.vue?vue&type=template&id=64f8ea0b&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=64f8ea0b&prod&lang=css"
import style1 from "./main.vue?vue&type=style&index=1&id=64f8ea0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8ea0b",
  null
  
)

export default component.exports